module.exports = __webpack_public_path__ + "grape_regulars-419ba.svg";